import React from 'react';
import Loadable from 'react-loadable';

var LoadableMarkdownPanel = Loadable({
  loader: function loader() {
    return import('./MarkdownPanel');
  },
  loading: function loading() {
    return React.createElement(
      'div',
      null,
      'Loading...'
    );
  }
});

export var MarkdownPanel = function MarkdownPanel(props) {
  return React.createElement(LoadableMarkdownPanel, props);
};